import InputField from "components/fields/InputField";
import Radio from "components/radio";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApiList from "services/apiList";
import { loginUser } from "services/users/authSlice";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import CustomButton from "components/button/custom_button";

export default function UserInfoEditModal(props) {
  var user = useSelector(currentUser);
  const { setShowModal } = props;
  const [gender, setGender] = useState(true);
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    username: "",
    firstname: "",
    lastname: "",
    register: "",
    email: "",
    phone: "",
  });
  const inputs = [
    {
      id: "pe1",
      name: "username",
      type: "text",
      placeholder: "e.g. manager",
      disabled: true,
      errorMessage:
        "Хэрэглэгчийн нэр 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!",
      label: "Хэрэглэгчийн нэр",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true,
    },
    {
      id: "pe2",
      name: "lastname",
      type: "text",
      placeholder: "Овог",
      errorMessage:
        "Овог 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!",
      label: "Овог",
      pattern:
        "^[QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnmабвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{3,16}$",
      required: true,
    },
    {
      id: "pe3",
      name: "firstname",
      type: "text",
      placeholder: "Нэр",
      errorMessage:
        "Нэр 3-16 тэмдэгтээс бүрдэх бөгөөд ямар нэгэн тусгай тэмдэгт оруулах ёсгүй!",
      label: "Нэр",
      pattern:
        "^[QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnmабвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{3,16}$",
      required: true,
    },
    {
      id: "pe4",
      name: "register",
      type: "text",
      placeholder: "Регистр",
      errorMessage: "Регистрийн дугаарыг кирилл үсгээр оруулна уу!",
      label: "Регистр",
      pattern:
        "^[абвгдеёжзийклмноөпрстуүфхцчшщъыьэюяАБВГДЕЁЖЗИЙКЛМНОӨПРСТУҮФХЦЧШЩЪЫЬЭЮЯ]{2}[0-9]{8}$",
      required: false,
    },
    {
      id: "pe5",
      name: "phone",
      type: "text",
      placeholder: "Утас",
      errorMessage: "Утасны дугаар оруулна уу!",
      label: "Утас",
      pattern: "^[0-9]{8}$",
      required: false,
    },
    {
      id: "pe6",
      name: "email",
      type: "text",
      placeholder: "Имэйл",
      errorMessage: "Имэйл хаяг зөв оруулна уу!",
      label: "Имэйл",
      pattern: "^[a-zA-Z0-9+_.]+@[a-zA-Z0-9]+.[a-zA-Z0-9]+$",
      required: false,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setValues((prevValues) => ({
        ...prevValues,
        username: user.username,
        firstname: user.firstname,
        lastname: user.lastname,
        register: user.register,
        email: user.email,
        phone: user.phone,
      }));

      setGender(user.gender);
    };

    fetchData();
  }, [user]);

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    if (!e.preventDefault()) {
      const token = user.token;
      const es = new ESService(token);
      var data = {
        username: values["username"],
        firstname: values["firstname"],
        lastname: values["lastname"],
        is_manager: user.is_manager,
        is_teacher: user.is_teacher,
        is_student: user.is_student,
        gender: gender,
      };

      if (values["email"] !== "" && values["email"] !== null) {
        data["email"] = values["email"];
      }
      if (values["phone"] !== "" && values["phone"] !== null) {
        data["phone"] = values["phone"];
      }
      if (values["register"] !== "" && values["register"] !== null) {
        data["register"] = values["register"];
      }
      es.put(ApiList.userUrl + user.id + "/", data).then((json) => {
        if (json["status"]) {
          dispatch(loginUser(json["data"]));
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none ">
        <div className="relative my-6 mx-auto w-auto max-w-3xl">
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white p-10 shadow-lg outline-none focus:outline-none">
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-2">
                <h3 className="text-2xl font-semibold">
                  Хэрэглэгчийн мэдээлэл засах
                </h3>
                <button
                  className="float-right ml-auto border-0 p-1 text-3xl font-semibold leading-none text-black outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>
              </div>
              {/*body*/}
              <div className="relative flex-auto overflow-x-hidden p-6 ">
                {/* USER INPUTS  */}
                <div className="grid grid-cols-2 gap-2">
                  {inputs.map((input, index) => (
                    <InputField
                      key={"key" + input.id}
                      id={input.id}
                      {...input}
                      value={values[input.name] || ""}
                      onChange={onChange}
                    />
                  ))}
                </div>

                <div className="mt-5 flex gap-4 ">
                  <Radio
                    value={gender}
                    onChange={(e) => setGender(true)}
                    checked={gender === true}
                    key="male"
                    name="gender"
                    color="bg-btn-1"
                    label="Эрэгтэй"
                  />{" "}
                  <Radio
                    value={gender}
                    onChange={(e) => setGender(false)}
                    checked={gender === false}
                    key="female"
                    name="gender"
                    color="bg-btn-1"
                    label="Эмэгтэй"
                  />
                </div>
              </div>
              {/*footer*/}
              <div className="border-slate-200 flex items-center justify-end rounded-b border-t border-solid p-6">
                <button
                  className="background-transparent mr-1 mb-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none transition-all duration-150 ease-linear focus:outline-none"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  Хаах
                </button>

                <CustomButton text="Хадгалах" type="submit" className="mr-3" />
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </div>
  );
}
